import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Divider } from '@mui/material';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { generateAnalogModel } from '../../../../store/actions/paragonProcessActions';
import {
  setDisplayAnalogModel,
  toggleShowAnalogPanelsAndShowAnalogModel,
} from '../../../../store/actions/visualOptionActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuFragment } from '../common/SceneMenuFragment';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function AnalogModelMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const isRoot = useAppSelector(isLoggedInUserRoot);
  const componentDesign = useAppSelector(getActiveComponentDesign);

  const showingAnalogModel = useAppSelector((state) => state.visualOptions.showAnalogModel);
  const showingAnalogPanels = useAppSelector((state) => state.visualOptions.showAnalogPanels);

  return (
    <SceneMenuContent>
      {isRoot && (
        <SceneMenuFragment>
          <SceneMenuItem
            icon={<RefreshIcon />}
            text="Regenerate Analog Model"
            disabled={componentDesign == null}
            onClick={() => {
              dispatch(generateAnalogModel(componentDesign!));
              monitor.recordInteraction('Regenerate Analog Model menu item clicked');
            }}
          />

          <Divider />
        </SceneMenuFragment>
      )}

      <SceneMenuItem
        icon={showingAnalogModel ? <VisibilityIcon /> : <VisibilityOffIcon />}
        text={`${showingAnalogModel ? 'Hide' : 'Show'} Analog Model`}
        onClick={() => {
          dispatch(setDisplayAnalogModel(!showingAnalogModel));
          monitor.recordInteraction('Toggle Analog Model menu item clicked');
        }}
      />

      <SceneMenuItem
        icon={showingAnalogPanels ? <VisibilityIcon /> : <VisibilityOffIcon />}
        text={`${showingAnalogPanels ? 'Hide' : 'Show'} Analog Panels`}
        onClick={() => {
          dispatch(toggleShowAnalogPanelsAndShowAnalogModel());
          monitor.recordInteraction('Toggle Analog Panels menu item clicked');
        }}
      />

      <Divider />

      <ToggleLockingMenuItem type="analogModel" context="single" />
    </SceneMenuContent>
  );
}
